import connection from '@/api/connection'

export const getLots = async ({ commit }) => {
  let url = `/lots/selectable`;

  await connection.get(url)
    .then(res => {
      const lots = res.data.data;
      commit('setLotsSelectable', lots);
    }).catch(err => {
      console.log('error', err);
    });
}

export const productlotById = async ({ commit }, id) => {
  commit('setLotIsLoading', true);
  await connection.get(`/lots/${id}`)
    .then(res => {
      commit('setLotDetail', res.data.data);
      commit('setLotIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLotIsLoading', false);
    });
}

export const storeLot = async ({ commit }, lot) => {
  commit('setLotIsCreating', true);
  await connection.post(`/lots/create`, lot)
    .then(res => {
      commit('saveNewLot', res.data);
      commit('setLotIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLotIsCreating', false);
    });
}

export const updateLot = async ({ commit }, lot ) => {
  commit('setLotIsUpdating', true);
  await connection.put(`/lots/${lot.id}/update`, lot)
    .then(res => {
      commit('saveUpdatedLot', res.data);
      commit('setLotIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLotIsUpdating', false);
    });
}

export const deleteLot = async ({ commit }, lot) => {
  commit('setLotIsDeleting', true);
  await connection.delete(`/lots/${lot.id}/delete`)
    .then(res => {
      commit('setDeleteLot', res.data);
      commit('setLotIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLotIsDeleting', false);
    });
}

export const findByName = async ({ commit }, name) => {
  commit('setLotIsFinding', true);
  commit('isLotByNameExist', null);

  await connection.post(`/lots/findByName`, {name})
    .then(res => {
      commit('isLotByNameExist', res.data.data);
      commit('setLotIsFinding', false);
    }).catch(err => {
      console.log('error', err);
      commit('setLotIsFinding', false);
    });
}
